<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">

            <v-data-table :headers="headers" :items="subject_group_offering_list" class="elevation-1 mytable" dense
                :search="search">

                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Offer Subject Group</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-row dense justify="center" align="center" class="mx-2 mt-3 mb-1">

                        <v-col cols="12" sm="4" md="3" class="d-flex justify-center">
                            <v-autocomplete
                                v-model="filter_ay"
                                :items="academic_year_list"
                                item-text="name"
                                item-value="id"
                                label="Academic Year"
                                outlined
                                dense
                                clearable
                            />
                        </v-col>

                        <v-col cols="12" sm="4" md="3" class="d-flex justify-center">
                            <v-autocomplete
                                v-model="filter_stream"
                                :items="stream_list"
                                item-text="name"
                                item-value="id"
                                label="Stream"
                                outlined
                                dense
                                clearable
                            />
                        </v-col>

                        <v-col cols="12" sm="4" md="3" class="d-flex justify-center">
                            <v-autocomplete
                                v-model="filter_standard"
                                :items="standard_list"
                                item-text="name"
                                item-value="id"
                                label="Standard"
                                outlined
                                dense
                                clearable
                            />
                        </v-col>

                        <v-btn color="primary mb-7 ml-2" @click="fetch()" small>Fetch</v-btn>

                    </v-row>

                    <span style="width: 20px"></span>

                    <v-row dense align="center">

                        <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>

                        <v-col class="mr-8" sm="6" md="5" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details />
                        </v-col>

                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" small v-on="on"  @click="setDefaultFilters()">
                                    Add Subject Group Offer
                                </v-btn>
                            </template>

                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text class="pb-2 mt-2 pl-7 pr-7">
                                        <v-row dense align="center" justify="center">
                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete label="Select Standard" v-model="editedItem.standard" outlined
                                                    :items="standard_list" item-text="name" item-value="id" dense />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete label="Select Stream" v-model="editedItem.stream" outlined
                                                    :items="stream_list" item-text="name" item-value="id" dense />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete label="Select Academic Year" v-model="editedItem.academicyear"
                                                    outlined :items="academic_year_list" item-text="name"
                                                    item-value="id" dense />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete label="Select Subject Group" v-model="editedItem.subjectgroup"
                                                    outlined :items="subject_group_list" item-text="name"
                                                    item-value="id" dense />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-switch
                                                    v-model="editedItem.is_choice_based"
                                                    label="Is Choice Based"
                                                    inset
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-actions class="justify-center pt-0">
                                        <v-btn class="button" @click="close()" :disabled="!valid">
                                            Cancel
                                        </v-btn>

                                        <v-btn color="primary button" @click="save" :disabled="!valid">
                                            {{ editedIndex === -1 ? 'Save' : 'Update' }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>

                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>

                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.is_choice_based="{ item }">
                    <v-chip
                        small
                        :color="item.is_choice_based ? 'green' : 'red'"
                        dark
                    >
                        {{ item.is_choice_based ? 'Yes' : 'No' }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        subjectgroup: "",
        standard: "",
        stream: "",
        academicyear: "",
        filter_ay:"",
        filter_standard:"",
        filter_stream:"",
        headers: [
            {
                text: "Sr No",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Stream",
                align: "left",
                sortable: false,
                value: "stream",
            },
            {
                text: "Standard",
                align: "left",
                sortable: false,
                value: "standard",
            },
             {
                text: "Subject Group",
                align: "left",
                sortable: false,
                value: "subjectgroup",
            },
            {
                text: "Academic Year",
                align: "left",
                sortable: false,
                value: "academicyear",
            },
            {
                text: "Choice Based",
                align: "left",
                sortable: false,
                value: "is_choice_based",
            },
            {
                text: "Actions",
                value: "action",
                sortable: false
            },
        ],

        subject_group_offering_list: [],
        subject_group_list: [],
        standard_list: [],
        stream_list: [],
        academic_year_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            subjectgroup: "",
            standard: "",
            stream: "",
            academicyear: "",
            is_choice_based: false

        },
        defaultItem: {
            id: "",
            subjectgroup: "",
            standard: "",
            stream: "",
            academicyear: "",
            is_choice_based: false
        },
        loader:false
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add Subject Group Offering" : "Edit Subject Group Offering";
        },
        filteredRuleList() {
            if (!this.search) return this.subject_group_offering_list;

            const txt = this.search.toLowerCase();

            return this.subject_group_offering_list.filter(item => (item.name || "").toLowerCase().includes(txt)
            );
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        "editedItem.standard"(val) {

            if (!this.isEditing) {
                this.editedItem.subjectgroup = "";
            }

            this.subject_group_list = [];

            if (val && this.editedItem.stream) {
                this.getSubjectGroupList();
            }
        },

       "editedItem.stream"(val) {

            if (!this.isEditing) {
                this.editedItem.subjectgroup = "";
            }

            this.subject_group_list = [];

            if (val && this.editedItem.standard) {
                this.getSubjectGroupList();
            }
        },
    },

    mounted(){
        this.onLoad()
    },

    methods: {
        downloadFile() {
            this.loader = true;

            const excelData = this.filteredRuleList.map((item, index) => ({
                "S.No": index + 1,
                "Stream": item.stream,
                "Standard": item.standard,
                "Subject Group Name": item.subjectgroup,
                "Academic Year": item.academicyear,
                "Choice Based": item.is_choice_based ? "Yes" : "No",
               
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Group Offering");
            XLSX.writeFile(workbook, "SubjectGroupOffering.xlsx");
            this.loader = false;
        },

        editItem(item) {
            this.isEditing = true;

            this.editedIndex = this.subject_group_offering_list.indexOf(item);

            this.editedItem = {
                id: item.id,
                subjectgroup: item.subject_id,
                standard: item.standard_id,
                stream: item.stream_id,
                academicyear: item.ay_id,
                is_choice_based: item.is_choice_based || false
            };

            this.getSubjectGroupList();

            this.dialog = true;
        },

        onLoad() {
            this.overlay = true;
            axios
                .post("/admission/getData")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.standard_list = res.data.standard_list;
                        this.stream_list = res.data.stream_list;
                        this.academic_year_list = res.data.ay_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        fetch() {
            this.overlay = true;
            const data = {
                selected_ay: this.filter_ay,
                selected_standard: this.filter_standard,
                selected_stream: this.filter_stream
            }
            axios
                .post("/admission/getSubjectOfferLists",data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg === "200") {
                        this.overlay = false;
                        this.subject_group_offering_list = res.data.subject_offer_list.map((item, index) => ({
                            ...item,
                            srno: index + 1
                        }));
                       
                        if(this.subject_group_offering_list.length <= 0){
                            this.showSnackbar("#b71c1c", "Data not present");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getSubjectGroupList() {
            this.overlay = true;
            const data = {
                standard: this.editedItem.standard,
                stream: this.editedItem.stream
            };

            axios
                .post("/admission/getSubjectGroupByStandardStream", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.subject_group_list =res.data.subject_group_list || [];
                        
                        if (this.subject_group_list.length <= 0) {
                            this.showSnackbar("#b71c1c","No Subject Groups Found For This Standard And Stream");
                        }
                    } else {
                        this.showSnackbar("#b71c1c","Unable to fetch Subject Groups");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("#b71c1c","Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                    this.isEditing = false;
                });
        },

        setDefaultFilters() {
            this.standard = this.filter_standard || "";
            this.stream = this.filter_stream || "";
            this.academicyear = this.filter_ay || "";
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.standard="",
            this.stream="",
            this.academicyear="",
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

      save() {
            if (!this.isValidated()) return;

            const payload = {
                id: this.editedItem.id,
                subjectgroup: Number(this.editedItem.subjectgroup),
                standard: Number(this.editedItem.standard),
                stream: Number(this.editedItem.stream),
                academicyear: Number(this.editedItem.academicyear),
                is_choice_based: this.editedItem.is_choice_based
            };

            if (this.editedIndex > -1) {

                axios.post("/admission/editSubjectGroupOffer", payload)
                    .then((res) => {
                        if (res.data.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Updated Successfully...");
                            this.close();
                            this.fetch();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Update Failed");
                        }
                    });

            } else {

                axios.post("/admission/saveSubjectGroupOffer", payload)
                    .then((res) => {
                        if (res.data.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Saved Successfully...");
                            this.close();
                            if(this.filter_ay && this.filter_standard && this.filter_stream){
                                this.fetch()
                            }
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Save Failed");
                        }
                    });
            }
        },

        isValidated() {
            if (!this.editedItem.subjectgroup) {
                this.showSnackbar("#b71c1c", "Select Subject Group...");
                return false;
            }

            if (!this.editedItem.standard) {
                this.showSnackbar("#b71c1c", "Select Standard...");
                return false;
            }

            if (!this.editedItem.stream) {
                this.showSnackbar("#b71c1c", "Select Stream...");
                return false;
            }

            if (!this.editedItem.academicyear) {
                this.showSnackbar("#b71c1c", "Select Academic Year...");
                return false;
            }

            return true;
        },

        deleteItem(item) {
            if (confirm("Are you sure you want to delete this Subject Group Offering?")) {
                const data = {
                    id: item.id
                };
                axios
                    .post("/admission/deleteSubjectGroupOffer", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Subject Group Offering Deleted Successfully...");
                            this.fetch();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
            this.close();
        }
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>